import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { lightBlue, MQ } from '@css/constants'

export const Title = styled('div')<{ expand: boolean }>(props => css`
  ${FontNormal(600)};
  ${fontSize(24)};
  text-align: center;
  max-width: 400px;
  margin: 0 auto;

  ${MQ.SMALL_SCREENS} {
    ${fontSize(20)};
    max-width: 'none';
  }

  sup {
    ${fontSize(12)};
  }
`)

export const ArticleList = styled('ul')(css`
  list-style: none;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`)

export const Article = styled('li')(css`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  & > svg {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
  }

  & sup {
    ${fontSize(12)};
    position: relative;
    bottom: 5px;
    vertical-align: baseline;
  }

  ${MQ.SMALL_SCREENS} {
    & > svg {
      align-self: baseline;
      width: 40px;
      height: 40px;
    }
  }
`)

export const ArticleText = styled('div')(css`
  ${FontNormal(400)};
  max-width: 371px;
  margin-left: 15px;
  text-align: left;

  & > b {
    ${FontNormal(600)};
  }

  ${MQ.SMALL_SCREENS} {
    ${fontSize(14)};
    margin-left: 6px;
  }
`)

export const Footer = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(12)};
  max-width: 361px;
  margin: 14px auto 0;
  text-align: left;

  & > a {
    ${FontNormal(600)};
    color: ${lightBlue};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ${MQ.SMALL_SCREENS} {
    max-width: 275px;
    margin-top: 24px;
  }
`)
